import React from 'react';

import {
  QueueTabBar,
  routeDirectory
} from 'modules';

import { useNavigate } from 'react-router-dom';
import * as dataService from './dataService';
import * as shared from '../shared';



const TabBar = QueueTabBar.genTabBarComponent({
  tabs: shared.tabs
});



export interface IProps {
  storeId?: string;
  searchText: string;
}

export const FC: React.FC<IProps> = props => {
  const params = shared.useReturnAuthorizationActivityParams();
  const queryTuple = dataService.useQuery(props.storeId, props.searchText);
  const navigate = useNavigate();
  const loading = queryTuple.loading;

  return (
    <TabBar
      loading={loading}
      value={params.tabId}
      tabId2ItemCount={{
        preAlertAcknowledged: queryTuple.data.numPreAlertAcknowledged,
        awaitingTriageObservation: queryTuple.data.numAwaitingTriageObservation,
        awaitingReturnDecision: queryTuple.data.numAwaitingReturnDecision,
        qualityControl: queryTuple.data.numAwaitingQualityControl,
        printLabel: queryTuple.data.numPrintLabel
      }}
      onChange={tabId => {
        const path = routeDirectory.admin.tier1ReturnAuthorizations.list.path(tabId, props.storeId, props.searchText);
        navigate(path, {
          replace: true
        });
      }} />
  );
};
